import { useState, React, useEffect, useContext } from 'react';
import { connect } from 'react-redux';
import _noop from 'lodash-es/noop';
import Button from 'sushiweb/Button';
import PropTypes from 'prop-types';
import Layout from 'sushiweb/Layout';
import ChevronLeft from 'sushiweb/Icons/all/ChevronLeft';
import Checkbox from 'sushiweb/InputTypes/Checkbox';
import H5 from 'sushiweb/Typography/Heading/H5';
import { P } from 'sushiweb/Typography/Text';
import H6 from 'sushiweb/Typography/Heading/H6';
import { getAllGroupsInitiate } from '../../../../../../actions/groups';
import {
  DottedLine,
  FundsSummaryText,
  FundsSummaryWrapper,
  InputWrapper,
} from '../../../../../WalletPrograms/styles';
import { genericErrorMsg } from '../../../../../../constants';
import {
  addProgramToGroup,
  reviewAddProgramToGroup,
} from '../../../../../../api/VoucherProgram';
import { formatAmountInRupees, getOrdinal } from '../../../../../../helpers';
import {
  openErrorToast,
  openSuccessToast,
} from '../../../../../../reducers/uiLogic';
import Card from '../../../../../common/components/Card';
import { FormCacheContext } from '../../../../../WalletPrograms/CreateProgramModal/ProgramForms/common/Components/FormTemplate/FormTemplate';
import {
  ReviewPlanButtonWrapper,
  StyledDisabledInput,
} from '../../../../../WalletPrograms/CreateProgramModal/ProgramForms/ReviewProgram/styles';
import { weekDays } from '../../../../../common/components/constants';
import { StyledLayout } from '../../../../../common/styles';
import { frequencyTypes } from '../../../../../WalletPrograms/constants';
import { WEEKLY } from '../../../../../WalletPrograms/CreateProgramModal/ProgramForms/common/Components/constants';
import { FundsSummaryIcon } from '../../../../../../components/SVGs/commonSVGs';

const ReviewPlan = ({
  getAllGroups,
  groupDetails,
  showErrorToast,
  showSuccessToast,
  closeModal,
}) => {
  const {
    bodyStyle,
    goToPrevStep,
    stepsVisibility,
    getCachedFormData,
    updateCachedFormData,
  } = useContext(FormCacheContext);
  const [currentCycle, setCurrentCycle] = useState(false);
  const [giveProRatedAmount, setGiveProRatedAmount] = useState(false);
  const [createLoading, setCreateLoading] = useState(false);
  const {
    reviewAddProgram: reviewAddProgramDetails,
    checkedPlan: plan,
    workspace_id: workspaceID,
  } = getCachedFormData();
  const [formData, setFormData] = useState(reviewAddProgramDetails);

  const {
    monthly_amount: amountMonthly = '',
    weekly_amount: amountWeekly = '',
    period: periodCycle = '-',
    payable_amount: payableAmount = '-',
    total_employees: totalEmployees = '-',
    applicable_days: applicableDays = '-',
    start_date: startDate = '-',
    cycle_type: cycleType = 0,
  } = formData;
  const monthlyStartDate = new Date(startDate.replace(' IST', '')).getDate();
  const ordinalForStartDate = getOrdinal(monthlyStartDate);
  const weeklyStartDay =
    weekDays[new Date(startDate.replace(' IST', '')).getDay()];

  useEffect(() => {
    stepsVisibility(false);
  }, []);

  const handleBackBtnClick = () => {
    stepsVisibility(true);
    goToPrevStep();
  };

  useEffect(() => {
    const body = {
      workspace_id: workspaceID,
      program_id: plan?.program_id,
      group_id: groupDetails?.group_id,
      to_be_added_in_current_cycle: currentCycle,
      to_be_given_pro_rated_amount: giveProRatedAmount,
    };

    reviewAddProgramToGroup(body)
      .then(res => {
        if (!res.status) {
          showErrorToast(genericErrorMsg);
          return;
        }
        updateCachedFormData({ reviewAddProgram: res });
        setFormData(res);
      })
      .catch(err => {
        console.error(err);
        showErrorToast(genericErrorMsg);
      });
  }, [currentCycle]);

  const handleCycleChange = () => {
    if (currentCycle) {
      setGiveProRatedAmount(false);
    }
    setCurrentCycle(!currentCycle);
  };

  const handleProRatedAmountChange = () => {
    setGiveProRatedAmount(!giveProRatedAmount);
  };
  const handleCreateBtnClick = () => {
    setCreateLoading(true);
    const body = {
      workspace_id: workspaceID,
      program_id: plan?.program_id,
      group_id: groupDetails?.group_id,
      programData: formData,
      to_be_added_in_current_cycle: currentCycle,
      to_be_given_pro_rated_amount: giveProRatedAmount,
    };
    addProgramToGroup(body)
      .then(res => {
        setCreateLoading(false);
        if (!res.status) {
          showErrorToast(genericErrorMsg);
          return;
        }
        showSuccessToast('Plan added to team successfully');
        closeModal();
        getAllGroups(body.workspace_id);
      })
      .catch(err => {
        console.error(err);
        setCreateLoading(false);
        showErrorToast(genericErrorMsg);
      });
  };

  return (
    <>
      <Card.Body style={bodyStyle}>
        <br />
        <StyledLayout gap={30}>
          <Layout.Item colD={6} colT={4} colM={12}>
            <InputWrapper>
              <StyledDisabledInput
                label='Employees count'
                value={totalEmployees}
                disabled
                showHelperText={false}
              />
            </InputWrapper>
          </Layout.Item>
          <Layout.Item colD={6} colT={4} colM={12}>
            <InputWrapper>
              <StyledDisabledInput
                label='Budget'
                value={
                  frequencyTypes[cycleType] === WEEKLY
                    ? `${formatAmountInRupees(amountWeekly)} / week`
                    : `${formatAmountInRupees(amountMonthly)} / month`
                }
                disabled
                showHelperText={false}
              />
            </InputWrapper>
          </Layout.Item>
          <Layout.Item colD={12} colT={12} colM={12}>
            <InputWrapper>
              <StyledDisabledInput
                label='Plan cycle'
                value={`${periodCycle}\t\t\t\t\t\t\t\t\t\t\t${applicableDays} Days`}
                disabled
                showHelperText={false}
              />
            </InputWrapper>
          </Layout.Item>
          {frequencyTypes[cycleType] !== WEEKLY && (
            <>
              <Layout.Item colD={6} colT={12} colM={12}>
                <Checkbox
                  checked={currentCycle}
                  onChange={handleCycleChange}
                  label='Switch to current cycle'
                />
              </Layout.Item>
              <Layout.Item colD={6} colT={12} colM={12}>
                <Checkbox
                  style={{ marginLeft: '15px' }}
                  checked={giveProRatedAmount}
                  onChange={handleProRatedAmountChange}
                  label='Give pro-rated amount'
                  disabled={!currentCycle}
                />
              </Layout.Item>
            </>
          )}
          <DottedLine> </DottedLine>
        </StyledLayout>
        <FundsSummaryWrapper>
          <FundsSummaryIcon />
          <FundsSummaryText>
            <H5>Funds summary</H5>
            <P>
              Updated plan cost is{' '}
              <H6>{formatAmountInRupees(payableAmount)}, </H6> topped-up{' '}
              {frequencyTypes[cycleType] === WEEKLY
                ? `every ${weeklyStartDay}`
                : `on ${monthlyStartDate}${ordinalForStartDate} of every month`}
            </P>
          </FundsSummaryText>
        </FundsSummaryWrapper>
      </Card.Body>
      <ReviewPlanButtonWrapper>
        <Button
          appearance='outline'
          icon={<ChevronLeft />}
          disabled={createLoading}
          iconAlign='left'
          btnColor='red'
          onClick={handleBackBtnClick}
        >
          Go back
        </Button>
        <Button onClick={handleCreateBtnClick} loading={createLoading}>
          Confirm and add plan
        </Button>
      </ReviewPlanButtonWrapper>
    </>
  );
};

ReviewPlan.propTypes = {
  groupDetails: PropTypes.objectOf(PropTypes.any),
  showErrorToast: PropTypes.func,
  showSuccessToast: PropTypes.func,
  closeModal: PropTypes.func,
  getAllGroups: PropTypes.func,
};

ReviewPlan.defaultProps = {
  groupDetails: {},
  showErrorToast: _noop,
  showSuccessToast: _noop,
  closeModal: _noop,
  getAllGroups: _noop,
};

const mapDispatchToProps = dispatch => ({
  showSuccessToast: message => dispatch(openSuccessToast(message)),
  showErrorToast: message => dispatch(openErrorToast(message)),
  getAllGroups: payload => dispatch(getAllGroupsInitiate(payload)),
});

export default connect(
  null,
  mapDispatchToProps,
)(ReviewPlan);
